const t = {
  prefix: "nova",
  assetsUrl: "https://cdn.matrix42.design/assets",
  theme: "nova",
  themeMode: "light",
  root: document,
  htmlFontSize: 16
};
export {
  t as defaultDesignSystemConfig
};
